<template>
    <span v-bind:class="labelClass">{{ this.value }}%</span>
</template>

<script>
    /**
     * @param {Number} value
     */
    export default {
        name: "PercentageItem",
        props: {
            value: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                labelClass: ''
            };
        },
        created() {
            if (this.value >= 0 && this.value <= 100) {
                switch (true) {
                    case this.value >= 75:
                        this.labelClass = 'text-success';
                        break;

                    case this.value >= 50:
                        this.labelClass = 'text-warning';
                        break;

                    case this.value >= 25:
                        this.labelClass = 'text-orange';
                        break;

                    default:
                        this.labelClass = 'text-danger';
                        break;
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/item/Percentage.vue